module.exports = __webpack_public_path__ + "static/media/350.0779c058.svg";